import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent as BaseDialogContent,
  DialogTitle,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  appEvents,
  fields
} from 'modules';

import * as dataService from './dataService';



const DialogContent = styled(BaseDialogContent)(({ theme }) => ({
  maxWidth: 420
}));


const ControlledTextField = fields.genTextFieldControllerComponent<dataService.IFormData>();



export interface IProps {
  userId: string;
  defaultEmail: string;
}

export const FC: React.FC<IProps> = props => {
  const { form, loading, mutations } = dataService.useCreateUserAccountModal(props.userId, props.defaultEmail);



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  async function processSubmit(formData: dataService.IFormData) {
    try {
      await mutations.createAccount(formData);
      handleClose();
    } catch (e) {
      alert(e);
    }
  }



  return (
    <Dialog
      open
      onClose={() => !loading && handleClose()}>

      <DialogTitle>
        Create User Account
      </DialogTitle>

      <form onSubmit={form.handleSubmit(processSubmit)}>
        <DialogContent>

          <Stack spacing={4}>
            <Typography>
              Please enter the following information to add the user to the platform.
            </Typography>

            <ControlledTextField
              label="Email"
              isDisabled={loading}
              formControl={form.control}
              fieldKey="email"/>

            <ControlledTextField
              label="Password"
              isDisabled={loading}
              formControl={form.control}
              fieldKey="password"
              type="password" />

            <ControlledTextField
              label="Confirm Password"
              isDisabled={loading}
              formControl={form.control}
              fieldKey="confirmPassword"
              type="password" />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            disabled={loading}
            color="secondary"
            onClick={handleClose}>
            Cancel
          </Button>

          <Button
            disabled={loading}
            type="submit">
            Confirm
          </Button>
        </DialogActions>
      </form>

    </Dialog>
  );
};
